import React from "react";
import { Multiselect, MultiselectProps } from "@amzn/awsui-components-console";
import { COUNTRY_OPTIONS, CountryCode } from "./constants";

export interface CountryFilterProps {
  selectedCountries: CountryCode[];
  accessibleCountries: CountryCode[];
  onChange: (selectedCountries: CountryCode[]) => void;
  testId?: string;
}

/**
 * Country filter multiselect component for WC claims history.
 * Displays only countries the user has access to based on their roles.
 */
export function CountryFilter({
  selectedCountries,
  accessibleCountries,
  onChange,
  testId = "country-filter",
}: CountryFilterProps) {
  const availableOptions = COUNTRY_OPTIONS.filter((option) =>
    accessibleCountries.includes(option.value as CountryCode)
  );

  const selectedOptions = availableOptions.filter((option) =>
    selectedCountries.includes(option.value as CountryCode)
  );

  const handleChange = ({ detail }: { detail: MultiselectProps.MultiselectChangeDetail }) => {
    const newSelectedCountries = detail.selectedOptions.map(
      (option) => option.value as CountryCode
    );
    onChange(newSelectedCountries);
  };

  return (
    <Multiselect
      data-testid={testId}
      selectedOptions={selectedOptions}
      onChange={handleChange}
      options={availableOptions}
      placeholder="Select countries"
      filteringType="auto"
      selectedAriaLabel="Selected countries"
    />
  );
}
